import { env } from '@/lib/config/env'

const NATIVE_SCOPES = ['openid', 'email', 'profile']

/**
 * True when Google sign-in must use the native Tauri plugin: the Android APK
 * and the iOS shell. Browsers (including the installed PWA) keep Google
 * Identity Services.
 */
export function usesNativeGoogleAuth(): boolean {
  return (
    env.isTauri() &&
    (env.clientPlatform === 'android' || env.clientPlatform === 'ios')
  )
}

/**
 * Google ID token through the native Tauri Google Auth plugin (D-076).
 *
 * Android uses the Credential Manager native flow and iOS the Google Sign-In
 * SDK. The Web Application client ID passed here is the ID-token audience the
 * rewrite API already validates (`GOOGLE_WEB_CLIENT_ID`); the Android OAuth
 * client (package name + SHA-1 of the signing certificate) is registered in
 * Google Cloud Console only for app verification and never appears in code.
 *
 * The plugin package is loaded lazily so the web bundle keeps its current
 * shape and browsers never execute the native bridge.
 */
export async function requestNativeGoogleIdToken(
  clientId: string,
): Promise<string> {
  const { signIn } = await import(
    '@choochmeque/tauri-plugin-google-auth-api'
  )
  const response = await signIn({ clientId, scopes: NATIVE_SCOPES })
  const idToken = response.idToken?.trim()
  if (!idToken) {
    throw new Error('Google returned no credential')
  }
  return idToken
}
